/** Shared dashboard link metadata for PG / IU / admin home shells. */

export const DASHBOARD_LINK_TEMPLATES = Object.freeze({
  requestBond: {
    name: "Request a Bond",
    path: "/bond-creation-outsider",
    iconKey: "description",
  },
  approveBonds: {
    name: "Approve Bonds",
    path: "/vermost_approve_bonds",
    iconKey: "thumbUp",
    feature: "approve_bonds",
  },
  uploadIndemnityAdmin: {
    name: "Upload Indemnity",
    path: "/vermost_manually_signed_indemnities",
    iconKey: "assignmentTurnedIn",
  },
  uploadIndemnityPg: {
    name: "Upload Indemnity",
    path: "/vermost_manually_signed_indemnities",
    iconKey: "descriptionSecondary",
  },
  bondCalculator: {
    name: "Bond Calculator",
    path: "/premium_calculator",
    iconKey: "calculate",
  },
  premiumCalculator: {
    name: "Premium Calculator",
    path: "/premium_calculator",
    iconKey: "calculate",
  },
  enhancementRequests: {
    name: "Enhancement Requests",
    path: "/create-enhancement-request",
    iconKey: "autoAwesome",
  },
  internalUsers: {
    name: "Internal Users",
    path: "/vermost_internal_users",
    iconKey: "people",
    feature: "internal_users",
  },
  lawFirms: {
    name: "Law Firms",
    path: "/vermost_lawfirm_list",
    iconKey: "gavel",
    feature: "law_firms",
  },
  professionalGuardians: {
    name: "Professional Guardians",
    path: "/vermost-professional-guardian-list",
    iconKey: "shield",
    feature: "professional_guardians",
  },
  legalServiceParalegals: {
    name: "Legal Service Paralegals",
    path: "/vermost_paralegals_list",
    iconKey: "badge",
    feature: "paralegals",
  },
  lawFirmUsers: {
    name: "Law Firm Users",
    path: "/vermost_law_firm_users",
    iconKey: "business",
    feature: "law_firm_users",
  },
  bondArchives: {
    name: "Bond Archives",
    path: "/vermost_bond_archives",
    iconKey: "archive",
    feature: "bond_archives",
  },
  analytics: {
    name: "Analytics",
    path: "/analytics",
    iconKey: "insertChart",
    feature: "analytics",
  },
  createHistoricBond: {
    name: "Create Historic Bond",
    path: "/bond-creation-outsider-historic",
    iconKey: "history",
    feature: "create_historic_bonds",
  },
  managePremiums: {
    name: "Manage Premiums",
    path: "/vermost_premiums_manager",
    iconKey: "monetizationOn",
    feature: "premiums",
  },
  bondTypes: {
    name: "Bond Types",
    path: "/bondtypes",
    iconKey: "category",
    feature: "bond_types",
  },
  bondNumbers: {
    name: "Bond Numbers",
    path: "/bond_numbers",
    iconKey: "verifiedUser",
    feature: "bond_numbers",
  },
  carriers: {
    name: "Carriers",
    path: "/vermost_carrier_list",
    iconKey: "accountBalance",
    feature: "carriers",
  },
  states: {
    name: "States",
    path: "/states",
    iconKey: "locationOn",
    feature: "states",
  },
  allEnhancementRequestsIu: {
    name: "All Enhancement Requests",
    path: "/view-enhancement-requests",
    iconKey: "supportAgent",
    feature: "enhancement_request",
  },
  allEnhancementRequestsAdmin: {
    name: "All Enhancement Requests",
    path: "/view-enhancement-requests",
    iconKey: "lightbulb",
  },
  supportRequests: {
    name: "Support Requests",
    path: "/admin/support-requests",
    iconKey: "contactSupport",
    feature: "support_requests",
  },
  announcements: {
    name: "Announcements",
    path: "/announcements",
    iconKey: "campaign",
    feature: "announcements",
  },
  obligees: {
    name: "Obligees",
    path: "/obligees",
    iconKey: "business",
  },
  lawSchools: {
    name: "Law Schools",
    path: "/law_schools",
    iconKey: "school",
  },
});

const T = DASHBOARD_LINK_TEMPLATES;

/** @param {keyof typeof DASHBOARD_LINK_TEMPLATES} key */
export function dashboardLink(key) {
  const { name, path, iconKey } = T[key];
  return { name, path, iconKey };
}

/** @param {keyof typeof DASHBOARD_LINK_TEMPLATES} key */
export function dashboardLinkWithFeature(key) {
  const { name, path, iconKey, feature } = T[key];
  return { name, path, feature, iconKey };
}

/** @param {(keyof typeof DASHBOARD_LINK_TEMPLATES)[]} keys */
export function dashboardLinksWithFeature(keys) {
  return keys.map((key) => dashboardLinkWithFeature(key));
}

/** @param {(keyof typeof DASHBOARD_LINK_TEMPLATES)[]} keys */
export function dashboardLinks(keys) {
  return keys.map((key) => dashboardLink(key));
}
